export const generativeAiAgentIdLogsBatchDetails = "/generative_ai/agent/:id/logs/batch_details";
